<template>
	<inertia-head title="Data Privacy Policy" />
	<div class="bg-trc-main">
		<div class="bg-black-25">
			<div class="content text-center">
				<div class="py-0">
					<h1 class="fw-bold text-white mb-2">Data Privacy Policy</h1>
					<h2 class="h4 fw-normal text-white-75 fs-sm"></h2>
				</div>
			</div>
		</div>
	</div>
	<div class="content content-full mt-5">
		<div class="block block-rounded">
			<div class="block-content block-content-full">
			<p>
				WE VALUE YOUR PRIVACY. Bo Sanchez, Inc. (BSI/Truly Rich Club) complies with
				the Data Privacy Act of 2012, enacted by Congress in August 2012 as Republic
				Act No. 10173, and its Implementing Rules and Regulations ("IRR"), issued by
				the National Privacy Commission. We are committed to safeguarding your
				privacy and ensuring that you continue to trust Truly Rich Club (TRC) with
				your personal information. When you interact with us, you may share personal
				information with us which allows identification of you as an individual
				(e.g. name, email, address, telephone number). This is known as "personal
				information".
				</p>
				<p>
					This BSI/Truly Rich Club privacy policy ("Privacy Policy") describes how Bo
					Sanchez, Inc./Truly Rich Club ("BSI", "TRC", "we" or "us") collects, uses,
					shares, and retains personal information that you provide us, or that we
					collect, when you use the BSI/TRC website located at
					<a href="https://trulyrichclub.com" target="_blank">https://trulyrichclub.com</a> and other websites owned or controlled by BSI/TRC
					(the "Sites") or related mobile applications, use BSI/TRC products and
					services and complete related forms, participate in BSI/TRC events, or
					communicate with one of our customer service representatives.
				</p>
				<p>
					We and our partners use technology such as browser cookies on our site to
					personalize content and ads, provide social media features, and analyze our
					traffic. You can change your mind and change your consent choices at any
					time by informing our staff or contacting our data protection office.
				</p>
			</div>
		</div>
	</div>
</template>

<script>
import { onMounted } from '@vue/runtime-core'
import AuthLayout from '../../../Layouts/AuthLayout'

window.dataLayer = window.dataLayer || [];
function gtag(){dataLayer.push(arguments);}
gtag('js', new Date());

gtag('config', window.gtag_id);

export default {
	layout: AuthLayout,
	setup() {
		onMounted(() => {
			document.body.style.overflow = null
			document.body.classList.remove('modal-open')
		})
	},
}
</script>
